import { useEffect } from "react";
import api from "../services/api";

export default function useLocationTracking() {
    useEffect(() => {
        const role = localStorage.getItem("role");
        if (role !== "delivery_partner") return;

        const pushLocation = () => {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    try {
                        const token = localStorage.getItem("token");

                        await api.put(
                            `/delivery/update-location?latitude=${position.coords.latitude}&longitude=${position.coords.longitude}`,
                            {},
                            { headers: { Authorization: `Bearer ${token}` } }
                        );
                    } catch (error) {
                        console.log("Location push failed:", error);
                    }
                },
                (err) => {
                    console.log("Geolocation error:", err);
                },
                { enableHighAccuracy: true }
            );
        };

        pushLocation();
        const interval = setInterval(pushLocation, 10000);
        return () => clearInterval(interval);
    }, []);
}